<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h1>Brand Theme Settings</h1>
                        <p >Customize your brand's theme colors</p>
                    </div>
                    <div class="card-body">
                        <div v-if="loading" class="text-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>

                        <div v-else>
                            <form @submit.prevent="saveThemeColors">
                                <!-- Sidebar Colors -->
                                <div class="section">
                                    <h3>Sidebar Colors</h3>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="sidbar_bg_color">Sidebar Background</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="sidbar_bg_color"
                                                        v-model="themeColors.sidbar_bg_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.sidbar_bg_color"
                                                        class="form-control"
                                                        placeholder="#1a1a1a"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="sidbar_text_color">Sidebar Text</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="sidbar_text_color"
                                                        v-model="themeColors.sidbar_text_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.sidbar_text_color"
                                                        class="form-control"
                                                        placeholder="#ffffff"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="sidebar_item_color">Sidebar Item</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="sidebar_item_color"
                                                        v-model="themeColors.sidebar_item_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.sidebar_item_color"
                                                        class="form-control"
                                                        placeholder="#cccccc"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="sidebar_item_hover_color">Sidebar Item Hover</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="sidebar_item_hover_color"
                                                        v-model="themeColors.sidebar_item_hover_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.sidebar_item_hover_color"
                                                        class="form-control"
                                                        placeholder="#ffffff"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="sidebar_item_active_color">Sidebar Item Active</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="sidebar_item_active_color"
                                                        v-model="themeColors.sidebar_item_active_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.sidebar_item_active_color"
                                                        class="form-control"
                                                        placeholder="#007bff"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="sidebar_item_active_hover_color">Sidebar Item Active Hover</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="sidebar_item_active_hover_color"
                                                        v-model="themeColors.sidebar_item_active_hover_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.sidebar_item_active_hover_color"
                                                        class="form-control"
                                                        placeholder="#0056b3"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="sidebar_item_hover_bg_color">Sidebar Item Hover Background</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="sidebar_item_hover_bg_color"
                                                        v-model="themeColors.sidebar_item_hover_bg_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.sidebar_item_hover_bg_color"
                                                        class="form-control"
                                                        placeholder="#2a2a2a"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Header Colors -->
                                <div class="section">
                                    <h3>Header Colors</h3>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="header_color">Header Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="header_color"
                                                        v-model="themeColors.header_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.header_color"
                                                        class="form-control"
                                                        placeholder="#333333"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="sub_header_color">Sub Header Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="sub_header_color"
                                                        v-model="themeColors.sub_header_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.sub_header_color"
                                                        class="form-control"
                                                        placeholder="#666666"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Card Colors -->
                                <div class="section">
                                    <h3>Card Colors</h3>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="card_1_color">Card 1 Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="card_1_color"
                                                        v-model="themeColors.card_1_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.card_1_color"
                                                        class="form-control"
                                                        placeholder="#f8f9fa"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="card_2_color">Card 2 Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="card_2_color"
                                                        v-model="themeColors.card_2_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.card_2_color"
                                                        class="form-control"
                                                        placeholder="#e9ecef"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="card_3_color">Card 3 Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="card_3_color"
                                                        v-model="themeColors.card_3_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.card_3_color"
                                                        class="form-control"
                                                        placeholder="#dee2e6"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="card_4_color">Card 4 Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="card_4_color"
                                                        v-model="themeColors.card_4_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.card_4_color"
                                                        class="form-control"
                                                        placeholder="#ced4da"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="card_5_color">Card 5 Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="card_5_color"
                                                        v-model="themeColors.card_5_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.card_5_color"
                                                        class="form-control"
                                                        placeholder="#adb5bd"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="card_6_color">Card 6 Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="card_6_color"
                                                        v-model="themeColors.card_6_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.card_6_color"
                                                        class="form-control"
                                                        placeholder="#6c757d"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Button Colors -->
                                <div class="section">
                                    <h3>Button Colors</h3>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="primary_button_bg_color">Primary Button Background</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="primary_button_bg_color"
                                                        v-model="themeColors.primary_button_bg_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.primary_button_bg_color"
                                                        class="form-control"
                                                        placeholder="#007bff"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="primary_button_text_color">Primary Button Text</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="primary_button_text_color"
                                                        v-model="themeColors.primary_button_text_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.primary_button_text_color"
                                                        class="form-control"
                                                        placeholder="#ffffff"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="success_button_bg_color">Success Button Background</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="success_button_bg_color"
                                                        v-model="themeColors.success_button_bg_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.success_button_bg_color"
                                                        class="form-control"
                                                        placeholder="#28a745"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="success_button_text_color">Success Button Text</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="success_button_text_color"
                                                        v-model="themeColors.success_button_text_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.success_button_text_color"
                                                        class="form-control"
                                                        placeholder="#ffffff"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="danger_button_bg_color">Danger Button Background</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="danger_button_bg_color"
                                                        v-model="themeColors.danger_button_bg_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.danger_button_bg_color"
                                                        class="form-control"
                                                        placeholder="#dc3545"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="danger_button_text_color">Danger Button Text</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="danger_button_text_color"
                                                        v-model="themeColors.danger_button_text_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.danger_button_text_color"
                                                        class="form-control"
                                                        placeholder="#ffffff"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Border Colors -->
                                <div class="section">
                                    <h3>Border Colors</h3>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="border_color">Border Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="border_color"
                                                        v-model="themeColors.border_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.border_color"
                                                        class="form-control"
                                                        placeholder="#dee2e6"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="border_hover_color">Border Hover Color</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="border_hover_color"
                                                        v-model="themeColors.border_hover_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.border_hover_color"
                                                        class="form-control"
                                                        placeholder="#adb5bd"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Input Box Colors -->
                                <div class="section">
                                    <h3>Input Box Colors</h3>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="input_box_border_color">Input Box Border</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="input_box_border_color"
                                                        v-model="themeColors.input_box_border_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.input_box_border_color"
                                                        class="form-control"
                                                        placeholder="#ced4da"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="input_box_text_color">Input Box Text</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="input_box_text_color"
                                                        v-model="themeColors.input_box_text_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.input_box_text_color"
                                                        class="form-control"
                                                        placeholder="#495057"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="input_box_bg_color">Input Box Background</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="input_box_bg_color"
                                                        v-model="themeColors.input_box_bg_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.input_box_bg_color"
                                                        class="form-control"
                                                        placeholder="#ffffff"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="input_box_hover_color">Input Box Hover</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="input_box_hover_color"
                                                        v-model="themeColors.input_box_hover_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.input_box_hover_color"
                                                        class="form-control"
                                                        placeholder="#e9ecef"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="input_box_active_color">Input Box Active</label>
                                                <div class="input-group">
                                                    <input
                                                        type="color"
                                                        id="input_box_active_color"
                                                        v-model="themeColors.input_box_active_color"
                                                        class="form-control color-picker"
                                                    >
                                                    <input
                                                        type="text"
                                                        v-model="themeColors.input_box_active_color"
                                                        class="form-control"
                                                        placeholder="#007bff"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Action Buttons -->
                                <div class="row mt-4">
                                    <div class="col-12">
                                        <button
                                            type="submit"
                                            class="btn-lg-green"
                                            :disabled="saving"
                                        >
                                            <span v-if="saving" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                                            {{ saving ? 'Saving...' : 'Save Theme Colors' }}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BrandThemeSettings',
  data: function () {
    return {
      loading: true,
      saving: false,
      brandId: '',
      themeColors: {
        sidbar_bg_color: '#1a1a1a',
        sidbar_text_color: '#ffffff',
        sidebar_item_color: '#cccccc',
        sidebar_item_hover_color: '#ffffff',
        sidebar_item_active_color: '#007bff',
        sidebar_item_active_hover_color: '#0056b3',
        sidebar_item_hover_bg_color: '#2a2a2a',
        header_color: '#333333',
        sub_header_color: '#666666',
        card_1_color: '#f8f9fa',
        card_2_color: '#e9ecef',
        card_3_color: '#dee2e6',
        card_4_color: '#ced4da',
        card_5_color: '#adb5bd',
        card_6_color: '#6c757d',
        primary_button_bg_color: '#007bff',
        primary_button_text_color: '#ffffff',
        success_button_bg_color: '#28a745',
        success_button_text_color: '#ffffff',
        danger_button_bg_color: '#dc3545',
        danger_button_text_color: '#ffffff',
        border_color: '#dee2e6',
        border_hover_color: '#adb5bd',
        input_box_border_color: '#ced4da',
        input_box_text_color: '#495057',
        input_box_bg_color: '#ffffff',
        input_box_hover_color: '#e9ecef',
        input_box_active_color: '#007bff'
      },
      defaultColors: {
        sidbar_bg_color: '#1a1a1a',
        sidbar_text_color: '#ffffff',
        sidebar_item_color: '#cccccc',
        sidebar_item_hover_color: '#ffffff',
        sidebar_item_active_color: '#007bff',
        sidebar_item_active_hover_color: '#0056b3',
        sidebar_item_hover_bg_color: '#2a2a2a',
        header_color: '#333333',
        sub_header_color: '#666666',
        card_1_color: '#f8f9fa',
        card_2_color: '#e9ecef',
        card_3_color: '#dee2e6',
        card_4_color: '#ced4da',
        card_5_color: '#adb5bd',
        card_6_color: '#6c757d',
        primary_button_bg_color: '#007bff',
        primary_button_text_color: '#ffffff',
        success_button_bg_color: '#28a745',
        success_button_text_color: '#ffffff',
        danger_button_bg_color: '#dc3545',
        danger_button_text_color: '#ffffff',
        border_color: '#dee2e6',
        border_hover_color: '#adb5bd',
        input_box_border_color: '#ced4da',
        input_box_text_color: '#495057',
        input_box_bg_color: '#ffffff',
        input_box_hover_color: '#e9ecef',
        input_box_active_color: '#007bff'
      }
    }
  },
  mounted () {
    console.log(this.$route.params.brandId)
    this.brandId = this.$route.params.brandId
    this.fetchThemeColors()
  },
  methods: {
    async fetchThemeColors () {
      try {
        this.loading = true
        const response = await this.$store.dispatch('getBrandThemeColors', this.brandId)

        if (response.body && response.body.data) {
          this.themeColors = { ...this.themeColors, ...response.body.data }
        }
      } catch (error) {
        console.error('Error fetching theme colors:', error)
        this.$notify({
          type: 'error',
          text: 'Failed to load theme colors. Using default values.'
        })
      } finally {
        this.loading = false
      }
    },

    async saveThemeColors () {
      try {
        this.saving = true

        const payload = {
          brandId: this.brandId,
          colors: this.themeColors
        }

        await this.$store.dispatch('updateBrandThemeColors', payload)

        this.$notify({
          type: 'success',
          text: 'Theme colors updated successfully!'
        })
      } catch (error) {
        console.error('Error updating theme colors:', error)
        this.$notify({
          type: 'error',
          text: 'Failed to update theme colors'
        })
      } finally {
        this.saving = false
      }
    },

    resetToDefaults () {
      this.themeColors = { ...this.defaultColors }
      this.$notify({
        type: 'info',
        text: 'Theme colors reset to defaults. Click Save to apply changes.'
      })
    }
  }
}
</script>

<style scoped>
.card {
  border: none;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.card-header {
  background: linear-gradient(135deg, #96b363 0%, #6a8f2a 100%);
  color: white;
  border-radius: 10px 10px 0 0 !important;
  padding: 2rem;
}

.card-header h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 600;
}

.card-body {
  padding: 2rem;
}

.section {
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e9ecef;
}

.section:last-child {
  border-bottom: none;
}

.section h3 {
  color: #333;
  margin-bottom: 1.5rem;
  font-weight: 600;
  border-left: 4px solid #007bff;
  padding-left: 1rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.color-picker {
  border: none;
  border-radius: 5px 0 0 5px;
  cursor: pointer;
  height: 38px;
}

.input-group .form-control {
  border-radius: 0 5px 5px 0;
  height: 38px;
}

.btn {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-secondary {
  background: #6c757d;
  border: none;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-2px);
}

.spinner-border {
  width: 1rem;
  height: 1rem;
}

@media (max-width: 768px) {
  .card-header {
    padding: 1.5rem;
  }

  .card-header h1 {
    font-size: 1.5rem;
  }

  .card-body {
    padding: 1.5rem;
  }

  .section {
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
  }
}
</style>
